"use client";
import { CustomDialog } from "@/components/custom/dialog";
import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import { useParams, useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();
  const params = useParams<{ name: string }>();
  const t = useTranslations("common");
  const handleClose = () => {
    router.back();
  };
  return (
    <CustomDialog
      open={true}
      title={t("mediaProductNotFound", { name: decodeURI(params?.name) })}
      onOpenChange={handleClose}
      description={t("mediaProductNotFoundDetail", {
        name: decodeURI(params?.name),
      })}
      buttons={<Button onClick={handleClose}>취소</Button>}
    ></CustomDialog>
  );
}
